import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import OwTitle from "../../../../shared/OwTitle/OwTitle";
import OwButton from "../../../../shared/OwButton/OwButton";
import SupplierContext from "../../../../../contexts/SupplierContext";
import UserContext from "../../../../../contexts/UserContext";
import IQBDUnitOfMeasureOption from "../../../../../models/QuickBooks Desktop/IQBDUnitOfMeasureOption";
import UnitOfMeasurementEnum from "../../../../../models/UnitOfMeasurementEnum";
import OwSelectOption from "../../../../shared/OwSelectOption/OwSelectOption";
import * as _ from "lodash-es";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import INotification from "../../../../../models/INotification";
import NotificationPositionEnum from "../../../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../../../models/NotificationLevelEnum";
import IQBDUomMappingsDTO from "../../../../../models/DTO/IQBDUomMappingsDTO";
import IQBDOnUomMappingsDTO from "../../../../../models/DTO/IQBDOnUomMappingsDTO";
import IGetSupplierDTO from "../../../../../models/DTO/IGetSupplierDTO";
import { Socket } from "socket.io-client";
import styled from "styled-components";
import UiContext from "@contexts/UiContext";
import { SocketContext } from "@contexts/SocketContext";

type Props = {
    closeSidebar: () => void;
};

type UomOptions = {
    title: string;
    value: UnitOfMeasurementEnum;
};

export const QbdUomMappingsSidebar: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const qbdUomOptions = supplierModel.Supplier_Integration.qbd_UnitOfMeasureOptions || [];

    const getOwUomOptions = () => {
        const options: UomOptions[] = [];

        const keys = Object.keys(UnitOfMeasurementEnum);

        for (const k of keys) {
            if (_.isNaN(Number(k))) {
                // @ts-expect-error
                options.push({ title: k, value: UnitOfMeasurementEnum[k] });
            }
        }

        return options;
    };

    const [owUomOptions, setUomOptions] = useState<UomOptions[]>(getOwUomOptions());
    const [saveActive, setSaveActive] = useState(false);
    const [uomMappings, setUomMappings] = useState(supplierModel.Supplier_Integration.qbd_UomMapping || {});

    useEffect(() => {
        socket.on(EndpointsEnum.QBDOnUomMappings, onMappings);

        return () => {
            socket.removeListener(EndpointsEnum.QBDOnUomMappings, onMappings);
        };
    }, []);

    const saveMappings = () => {
        const payload: IQBDUomMappingsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            mapping: uomMappings,
        };

        socket.emit(EndpointsEnum.QBDUomMappings, payload);
    };

    const onMappings = (data: IQBDOnUomMappingsDTO) => {
        const notification: INotification = {
            message: "successfully_saved_uom_mappings",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        uiContext.notifyFn(null, notification);

        getSupplier();

        props.closeSidebar();
    };

    const getSupplier = () => {
        const payload: IGetSupplierDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.SupplierGetSupplier, payload);
    };

    const setUomMapping = (uomOption: IQBDUnitOfMeasureOption, selectedOwUom: ChangeEvent<any>) => {
        const existingMappings = {
            ...uomMappings,
        };

        existingMappings[uomOption.ListID] = {
            ow_uom: selectedOwUom.target.value,
            name: uomOption.BaseUnit?.Name || "",
        };

        setUomMappings(existingMappings);
    };

    return (
        <QbdUomMappingsSidebarWrapper className={"QbdUomMappingsSidebar p-3"}>
            <div className={"d-flex align-items-center justify-content-between"}>
                <div>
                    <OwTitle title={"edit_unit_of_measure_mappings"} tag={"h4"} />
                </div>
                <div>
                    <OwButton className={"bg-danger"} centerIconClass={"fas fa-times"} fn={props.closeSidebar} />
                </div>
            </div>

            <div className="mt-4">
                <div className={"d-flex"}>
                    <div className={"w-50"}>
                        <OwLabel title={"quickbooks_desktop"} />
                    </div>
                    <div className={"w-50"}>
                        <OwLabel title={"orderwerks"} />
                    </div>
                </div>
                {qbdUomOptions.map((uomOption) => {
                    return (
                        <div className={"mt-4 d-flex"} key={uomOption.ListID}>
                            <div className={"w-50"}>
                                <div>{uomOption.Name}</div>
                                <div>({uomOption?.BaseUnit?.Abbreviation})</div>
                            </div>
                            <div className={"w-50"}>
                                <OwSelectOption
                                    name={"selectedOption"}
                                    fn={(value: ChangeEvent<any>) => {
                                        setUomMapping(uomOption, value);
                                    }}
                                    options={owUomOptions}
                                    titleProp={"title"}
                                    valueProp={"value"}
                                    selectedOption={uomMappings[uomOption.ListID]}
                                    selectedOptionProp={"ow_uom"}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className={"mt-4"}>
                <OwButton title={"save"} fn={saveMappings} active={saveActive} disableOnActive={true} />
            </div>
        </QbdUomMappingsSidebarWrapper>
    );
};

const QbdUomMappingsSidebarWrapper = styled.div`
    max-height: 100vh;
    overflow-y: scroll;
`;
